import { Button } from '@rocco/components/button';
import { Send } from 'lucide-react';

/**
 * Displays a message when section content is not available with an option to request information
 */

interface SectionNotAvailableProps {
    description: React.ReactNode;
    enquiryButtonText: string;
    openEnquiryModal: () => void;
}

export const SectionNotAvailable = ({
    enquiryButtonText,
    description,
    openEnquiryModal,
}: SectionNotAvailableProps) => {
    return (
        <div className="flex flex-col items-start gap-8 pb-17 pt-8">
            <p className="text-lg">{description}</p>
            <Button color="primary" onClick={() => openEnquiryModal()}>
                {enquiryButtonText}
                <Send className="ml-2 size-4" />
            </Button>
        </div>
    );
};
